import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const CHIP = {
  yellow: "bg-amber-50 text-amber-600",
  green: "bg-emerald-50 text-emerald-600",
  cyan: "bg-sky-50 text-sky-600",
  white: "bg-zinc-100 text-zinc-700",
};

export default function KpiCard({ label, value, suffix, trend, icon: Icon, accent = "yellow", testid }) {
  return (
    <div
      className="bg-white border border-zinc-200/70 rounded-2xl p-5 transition-colors hover:border-zinc-300"
      data-testid={testid}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400 mt-1">{label}</div>
        {Icon && (
          <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${CHIP[accent] || CHIP.white}`}>
            <Icon size={16} strokeWidth={2} />
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-1.5">
        <div className="font-mono font-semibold text-3xl tracking-tight text-zinc-900">{value}</div>
        {suffix && <div className="text-xs text-zinc-400 font-mono">{suffix}</div>}
      </div>
      {trend !== undefined && trend !== null && (
        <div className={`mt-3 flex items-center gap-1 text-xs font-mono ${trend >= 0 ? "text-emerald-600" : "text-rose-500"}`}>
          {trend >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
          {trend >= 0 ? "+" : ""}{trend}%
          <span className="text-zinc-400 ml-1">vs mese scorso</span>
        </div>
      )}
    </div>
  );
}
